import {LeadDetailTypes} from "../../classes/Api/Lead";
import {openInNewTab} from "../../utils";

export default {
    data() {
        return {
            appraisals: []
        }
    },
    created() {
        this.setValues(this.value)
    },
    watch: {
        value: {
            handler(n, o) {
                if (n !== o) {
                    this.setValues(n)
                }
            },
            deep: true
        }
    },
    methods: {
        existingVehicleCheck(vehicle, continueCallBack) {
            if (this.appraisals.find(appraisal => appraisal.vehicle.id === vehicle.id)) {
                alert('The vehicle is already attached to this lead.')
                return
            }

            continueCallBack();
        },
        showVehicle(vehicle) {
            openInNewTab(`vehicles/${vehicle.id}/overview`)
        },
        showAppraisal(appraisal) {
            this.$refs['appraisal'].open(appraisal.id, appraisal)
        },
        setValues(value) {
            this.vehiclesOfInterest = value.vehiclesOfInterest
            this.appraisals = value.vehiclesOffered
        },
        addAppraisal() {
            this.$refs['appraisal'].open()
        },
        finishAddingAppraisal(appraisal) {
            if (!this.leadId) {
                if (!appraisal.id) {
                    const existingIndex = this.appraisals.findIndex((existingAppraisal) => {
                        return appraisal.vehicle.id === existingAppraisal.vehicle.id
                    })

                    if (existingIndex === -1) {
                        this.appraisals.push(appraisal)
                    } else {
                        this.$set(this.appraisals, existingIndex, appraisal)
                    }
                } else {
                    const index = this.appraisals.findIndex((existingAppraisal) => {
                        return appraisal.id === existingAppraisal.id
                    })

                    this.$set(this.appraisals, index, {
                        ...this.appraisals[index],
                        ...appraisal
                    })
                }
            }

            this.$emit('added', {
                type: LeadDetailTypes.VEHICLE_OFFERED,
                appraisal
            })
        },
        removeAppraisal(e) {
            if (confirm('Are you sure you want to remove the vehicle?')) {
                this.appraisals = this.appraisals.filter(i => {
                    return e.id !== i.id
                })

                this.$emit('removed', {
                    type: LeadDetailTypes.VEHICLE_OFFERED,
                    appraisal: e
                })
            }
        },
    }
}